/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'cookie-utils',
    'breakpoints',
    'pip-domain'
], function (
    $,
    Mustache,
    pip,
    cookieUtils,
    breakpoints,
    pipDomain
) {

    var view = {
        init: function init() {
            view.updateDom.bannerMessage();
        },
        selectors: {
            repeatPurchaseBannerContainer: '#repeat-purchase-banner-container',
            repeatPurchaseBanner: '.repeat-purchase-order-single-message'
        },
        templates: {
            repeatPurchaseBannerMessage: $('#repeat-purchase-banner-message__wrapper').html()
        },
        render: {
            banner: function renderBanner() {
                return Mustache.render(view.templates.repeatPurchaseBannerMessage, viewModel)
            }
        },
        updateDom: {
            bannerMessage: function updateBannerMessage() {
                var isSmallBreakPoint = breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small');
                $(view.selectors.repeatPurchaseBannerContainer).html(view.render.banner());
                if (isSmallBreakPoint && $(view.selectors.repeatPurchaseBanner).hasClass('u__medium')) {
                    $(view.selectors.repeatPurchaseBanner).removeClass('u__medium');
                }
            }
        },
    };
    var model = {
        // get Data From Api
        customerId: cookieUtils.getSVOCID(),
        getData: function getData (customerId) {
            return $.ajax({
                url: pipDomain.getDomain() + '/uds/v1/' + customerId + "/recent_purchase_history?key=2zSR74pj5Rq6zDtHENHkAScT4RWsl0pg&months=24",
                cache: false,
                dataType: "jsonp"
            })
        }
    };
    var viewModel = {
        displayBanner: false,
        update: function(data) {
            viewModel.isMobile = pip && pip.platform === "MOBILE";
            var itemId = pip.products.primary.data.itemId;

            if (!data || !data.pr || !data.pr.online) return;
            var matchingOrdersArr;
            if (data.pr.online.length > 0) {
                matchingOrdersArr = data.pr.online.filter(function (orders){
                    return orders.productId.indexOf(itemId) !== -1
                }).sort(function (a,b) {
                    return new Date(b.ts) - new Date(a.ts)
                })
            }
            viewModel.orderedTimes = (matchingOrdersArr && matchingOrdersArr.length) || 0;
            viewModel.orderedMoreThanOnce = viewModel.orderedTimes > 1;
            viewModel.displayBanner = viewModel.orderedTimes > 0;
            viewModel.lastPurchaseRawDate = viewModel.orderedTimes > 0 ? matchingOrdersArr[0].ts : null;
            viewModel.lastPurchaseFormattedDate = viewModel.lastPurchaseRawDate ? dateFormatter(viewModel.lastPurchaseRawDate) : null;
        }
    };

    function dateFormatter (rawDate) {
        var month = new Date(rawDate).toLocaleString('en-us', {month:'short'});
        var date = new Date(rawDate).getDate();
        var year = new Date (rawDate).getFullYear();
        return month +". " + date + ", " + year
    }

    function isRepeatPurchaseBannerEnabled () {
        return !!(pip.features && pip.features.repeatPurchaseBannerEnabled)
    }

    return {
        init: function () {
            if (isRepeatPurchaseBannerEnabled() && model.customerId) {
                model.getData(model.customerId)
                .then(function(data) {
                    viewModel.update(data);
                    if(viewModel.displayBanner) {
                        view.init();
                    }
                })
            }
        },
        model: model,
        viewModel :viewModel,
        view: view,
        isRepeatPurchaseBannerEnabled: isRepeatPurchaseBannerEnabled
    }
})

}.call(window));